import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const StrikeUp = () => {
  const tileId = useTargetAccumulatorTileId();
  const strikeUp = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.strikeUp);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('StrikeUp') ?? false,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleStrikeUp = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Strike Up changed',
      isDefined(value) ? String(value) : 'cleared',
    );

    return checkTargetAccumulatorWithTradeCapture({
      strikeUp: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.strikeUp">
      <TradeCaptureValidationWrapper validation={validation?.strikeUp}>
        <SgNumberInput
          valuePosition="start"
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          selectAllOnFocus
          value={strikeUp}
          maxDecimals={9}
          onChange={handleStrikeUp}
          size="sm"
          data-e2e="strikeUp"
          allowNegative={false}
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default StrikeUp;
